import rp from 'request-promise';
import config from '../../config';
import jwt_decode from 'jwt-decode';
import i18n from 'i18next';
import { getTenantHeaders } from '../../components/TenantHeaders';

export const initialState = {
  isLoading: false,
  isAuthenticated: !!localStorage.getItem('id_token'),
  error: null,
};

export const START_LOGIN = 'Login/START_LOGIN';
export const LOGIN_SUCCESS = 'Login/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'Login/LOGIN_FAILURE';
export const RESET_ERROR = 'Login/RESET_ERROR';
export const LOGIN_USER = 'Login/LOGIN_USER';
export const SIGN_OUT_SUCCESS = 'Login/SIGN_OUT_SUCCESS';

export const startLogin = () => ({
  type: START_LOGIN,
});

export const loginSuccess = () => ({
  type: LOGIN_SUCCESS,
});

export const loginFailure = () => ({
  type: LOGIN_FAILURE,
});

export const resetError = () => ({
  type: RESET_ERROR,
});

export const loginUser = (login, password) => async (dispatch) => {
  dispatch(startLogin());
  if (!!login && !!password) {
    let detail = {
      username: login,
      password: password,
    };
    const header = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };
    try {
      const res = await rp.post(`${config.api.url_auth}/${config.api.version}/auth/login`, {
        body: detail,
        json: true,
        authorization: true,
        resolveWithFullResponse: true,
        headers: header,
      });
      if (res.statusCode === 200) {
        const data = res.body || null;

        localStorage.setItem('id_token', data.IdToken);
        localStorage.setItem('access_token', data.AccessToken);
        localStorage.setItem('refresh_token', data.RefreshToken);
        localStorage.setItem('i18nextLng', 'th-TH');
        i18n.changeLanguage('th-TH');

        await getUserInfo(data.IdToken);
        await getTenantInfo(data.IdToken);
        dispatch(loginSuccess());
      }
    } catch (err) {
      dispatch(loginFailure());
    }
    // if (login === 'admin' && password === 'admin') {
    //   setTimeout(() => {
    //     localStorage.setItem("id_token", "2");
    //     dispatch(loginSuccess());
    //   }, 2000);
    // } else {
    //   setTimeout(() => {
    //     localStorage.setItem("id_token", "1");
    //     dispatch(loginSuccess());
    //   }, 2000);
    // }
  } else {
    dispatch(loginFailure());
  }
};

export const signOutSuccess = () => ({
  type: SIGN_OUT_SUCCESS,
});

export const signOut = () => {
  // if (config.firebase.status) {
  //   if (localStorage.getItem("select_module")) {
  //     const modules = JSON.parse(localStorage.getItem("select_module"));
  //     const fcmToken = localStorage.getItem("fcm_token");
  //     modules.forEach(val => {
  //       console.log(`unSubscribeFCM Topic : ${val}_module_alert`);
  //       unSubscribeFCM(fcmToken,`${val}_module_alert`);
  //     })
  //   }

  // }
  localStorage.removeItem('id_token');
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('role');
  localStorage.removeItem('role_id');
  localStorage.removeItem('user');
  localStorage.removeItem('user_id');
  localStorage.removeItem('fcm_token');
  localStorage.removeItem('location_permission');
  localStorage.removeItem('group_permission');
  localStorage.removeItem('subgroup_permission');
  localStorage.removeItem('select_module');
  localStorage.removeItem('select_group');
  localStorage.removeItem('sort');
  localStorage.removeItem('i18nextLng');
  localStorage.removeItem('mute_notification');
  localStorage.removeItem('subgroup_type');
  localStorage.removeItem('last_view');
  localStorage.removeItem('patient_id');
  localStorage.removeItem('tenantInfo');
  localStorage.removeItem('tenant_permission');
  localStorage.removeItem('select_tenant');
  // dispatch(signOutSuccess());
  window.location.replace('login');
};

export default function LoginReducer(state = initialState, { type, payload }) {
  switch (type) {
    case START_LOGIN:
      return {
        ...state,
        isLoading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        error: null,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: true,
      };
    case RESET_ERROR:
      return {
        error: false,
      };
    case SIGN_OUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
      };
    default:
      return state;
  }
}

async function getUserInfo(IdToken) {
  const decoded = jwt_decode(IdToken);
  const resUser = await rp
    .get(`${config.api.url}/${config.api.version}/users/name/${decoded['cognito:username']}`, {
      body: null,
      json: true,
      authorization: true,
      resolveWithFullResponse: true,
    })
    .auth(null, null, true, IdToken);
  if (resUser.statusCode === 200) {
    const user = resUser.body || null;
    localStorage.setItem('role', user.role);
    localStorage.setItem('role_id', user.role_id);
    localStorage.setItem('location_permission', user.locationPermission);
    localStorage.setItem('tenant_permission', user.tenantPermission);
    localStorage.setItem('group_permission', user.groupPermission);
    localStorage.setItem('subgroup_permission', user.subgroupPermission);
    localStorage.setItem('user', user.user);
    localStorage.setItem('user_id', user.id);
  }
}

async function getTenantInfo(IdToken) {
  try {
    const resTenantInfo = await rp
      .get(`${config.api.url}/${config.api.version}/tenant/basic/info`, {
        body: null,
        json: true,
        authorization: true,
        resolveWithFullResponse: true,
        headers: {
          ...getTenantHeaders(),
        },
      })
      .auth(null, null, true, IdToken);
    if (resTenantInfo.statusCode === 200) {
      const tenantInfo = resTenantInfo.body || [];
      localStorage.setItem('tenantInfo', JSON.stringify(tenantInfo));
    }
  } catch (err) {
    console.log('tenantInfo err', err);
  }
}

// async function unSubscribeFCM(token, topic) {
//   try {
//     const res = await rp
//       .post(`${config.api.url}/${config.api.version}/fcm/unsubscribe`, {
//         authorization: true,
//         body: {
//           topic,
//           token,
//         },
//         resolveWithFullResponse: true,
//         json: true,
//       })
//       .auth(null, null, true, localStorage.getItem('id_token'));
//     console.log('unsubscribe return :', res);
//   } catch (err) {
//     console.log('unsubscribe err', err);
//   }
// }
